import { computed } from 'vue'
import store from '@/store'
import router from '@/router'
import eventBus from '@/eventBus'

// 由于实验原因,有多个会员订阅页面,具体跳转到哪个不用关心,无脑调用这个就行
export default function useSubscribe() {
  const hasSvipEntryGroup = computed(() => store.getters['subscribe/hasSvipEntryGroup'])
  const isVip = computed(() => store.state.common.userVipInfo?.vcp_status)

  const navigateToSubscribe = ({ source, swipeIndex, anchor = 'vip' }) => {
    const strategies = [
      {
        condition: () => hasSvipEntryGroup.value,
        execute: () => router.push({ path: '/subscribe-v2', query: { source, anchor } }),
      },
      {
        condition: () => isVip.value,
        execute: () => router.push({ path: '/Subscriber' }),
      },
      {
        condition: () => true,
        execute: () => eventBus.$emit('SHOW_SUBSCRIBE_DIALOG', { source, swipeIndex})
      },
    ]
    const strategy = strategies.find(({ condition }) => condition())
    if (strategy) strategy.execute()
  }

  return {
    navigateToSubscribe,
  }
}
